@if (isQa) {
<div class="environment-banner">Molibra — QA</div>
} @if (isShellRoute()) {
<ui-app-shell ariaLabel="Molibra mobile app" [hasTabbar]="showPrimaryTabbar()">
  <router-outlet />

  @if (showPrimaryTabbar()) {
  <ui-tabbar
    uiAppShellTabbar
    [activeItemId]="activeMainTabId()"
    [items]="primaryTabs"
    ariaLabel="Molibra primary navigation"
    (activeItemIdChange)="handlePrimaryTabSelected($event)"
  />
  }
</ui-app-shell>
} @else {
<router-outlet />
}
